<template>
  <v-dialog
    v-model="showModal"
    persistent
    :max-width="getWidth"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2" v-if="!modalloading">
        <h3 style="word-break: break-word">{{ showTitle }}</h3>
      </v-card-title>
      <v-card-text class="pt-2 pb-2"
        >
        <div v-if="rejectReason">
            <el-autocomplete
              @change="setDescriptions()"
              required
              :items="classifiers['reject-reason']"
              itemvalue="value"
              itemtext="text"
              :label="'Atmetimo priežastis'"
              tooltip="Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Modalas. Pranešimo atmetimo priežastis"
              v-model="rejectReasonId"
            />
        </div>
        <div v-if="rejectReason">
          <el-textarea
              required
              :counter="2000"
              label="Aprašymas (LT)"
              v-model="rejectReasonText"
            />
        </div>

        <div v-if="rejectReason">
          <el-textarea
              required
              :counter="2000"
              label="Aprašymas (EN)"
              v-model="rejectReasonTextEN"
            />
        </div>
        <h5 v-if="info" v-html="showText"></h5>
        <h5 v-else>{{ showText }}</h5></v-card-text
      >
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <template v-if="info">
           <el-button
          title="Atgal"
          :loading="loading"
          @click.native.stop="closeModal()"
          color="secondary"
        />
        </template>
        <template v-else>
        <el-button
          :title="falseText"
          :loading="loading"
          @click.native.stop="closeModal()"
          color="secondary"
        />
        <el-button
          :title="trueText"
          :loading="loading"
          @click.native="confirmData()"
          color="primary"
        />
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import errorNotifications from '@/mixins/errorNotifications'

export default {
  name: 'ModalConfirm',
  mixins: [errorNotifications],
  props: {
    value: Boolean,
    title: String,
    text: String,
    loading: Boolean,
    code: String,
    info: Boolean,
    rejectReason: Boolean,
    width: String,
    rejectReasonType: String,
    trueText: { type: String, default: 'Taip' },
    falseText: { type: String, default: 'Ne' },
  },
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
      rejectReasonText: '',
      rejectReasonTextEN: '',
      classifiers: {},
      rejectReasonId: '',
    }
  },
  computed: {
    getWidth(){
      if (this.width) {
        return this.width
      }
      if(this.info || this.rejectReason){
        return '500px'
      } 
      return '300px'
    },
    showTitle() {
      return this.title
    },
    textByCode() {
      return this.notificationText(this.code)
    },
    showText() {
      return this.code ? this.textByCode : this.text
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  created() {
    if(this.rejectReasonType) {
      this.getClassifiers()
    }
    this.modalloading = false
    
  },
  methods: {
    getClassifiers() {
      this.loadDefault = true
      let arr = []
      let search = {}
      search.key = 'type'
      search.value = this.rejectReasonType
      arr.push(search)
      let requiredClassifiers = { classifiers: ['reject-reason','reject-reason-descriptions'], search: arr }
      this.$axios
        .post(`classifiers`, requiredClassifiers)
        .then((res) => {
          this.classifiers = res.data.classifiers
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loadDefault = false
        })
    },
    setDescriptions(){
      let id = this.rejectReasonId
      let langLt = this.classifiers['reject-reason-descriptions'].lt
      let langEn = this.classifiers['reject-reason-descriptions'].en
      this.rejectReasonText =  langLt.filter((item) => item.value === id)[0].text
      this.rejectReasonTextEN =  langEn.filter((item) => item.value === id)[0].text
    },
    closeModal() {
      this.showModal = false
      this.$emit('closeConfirmModal')
    },
    cancel() {
      this.closeModal()
    },
    confirmData() {
      if(this.rejectReason){
        this.$validator.validateAll().then((res) => {
          if (res) {
            this.$emit('rejectReasonText', this.rejectReasonText)
            this.$emit('rejectReasonTextEN', this.rejectReasonTextEN)
            this.$emit('confirmData')
          } else {
            this.$root.$emit('FORMAT_ERROR')
          }
        })
      } else {
      this.$emit('confirmData')
      }
     
    },
  },
}
</script>
<style lang="scss" scoped></style>
